import { IonRow } from '@ionic/react';
import { WrapperDiv } from './Copyright.styles';

interface IComponentProps { }

const Copyright: React.FC<IComponentProps> = () => {
  const dt = new Date();
  return (
    <IonRow className="app-copyright">
      <WrapperDiv className="app-copyright-item">
        {`copyright (${dt.getFullYear()}) - Auto-IT - all rights reserved`}
      </WrapperDiv>
    </IonRow>
  );
};

export default Copyright;
